import { render } from "./SystemHealth.vue?vue&type=template&id=9928047a&scoped=true"
import script from "./SystemHealth.vue?vue&type=script&lang=js"
export * from "./SystemHealth.vue?vue&type=script&lang=js"

import "./SystemHealth.vue?vue&type=style&index=0&id=9928047a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9928047a"]])

export default __exports__